module.exports = __webpack_public_path__ + "img/instrument-reducing-costs.e6d29e90.png";